(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8510],{

/***/ 24792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44012);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54269);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
 // import Link from "next/link";








var Complaints = function Complaints() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      language = _useState[0],
      setLanguage = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // console.log("Calling ads");
    // if (!isFirstTime) {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_1__/* .getLanguage */ .G3)());
    setTimeout(function () {
      window.googletag = window.googletag || {
        cmd: []
      };
      googletag.cmd.push(function () {
        googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
        var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
      });
      googletag.pubads().refresh(); // if (typeof apstag !== "undefined") {
      //   apstag.init({
      //     pubID: "7f0bbd82-5a13-48ec-9950-fcb028b1546c",
      //     adServer: "googletag",
      //     bidTimeout: 2e3,
      //   });
      //   // request the bids for the four googletag slots
      //   apstag.fetchBids(
      //     {
      //       slots: [
      //       ],
      //     },
      //     function (_) {
      //       // set apstag bids, then trigger the first request to GAM
      //       googletag.cmd.push(function () {
      //         apstag.setDisplayBids();
      //         googletag.pubads().refresh();
      //       });
      //     }
      //   );
      // }
    }, 500); // }
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "factcheck-complaint",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul", {
        className: "breadcrumb aa",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: "/",
            passHref: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("a", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("i", {
                className: "icon-cat-home"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  id: "home",
                  defaultMessage: "\u0939\u094B\u092E"
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: "/factcheck",
            passHref: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                  id: "fact_check",
                  defaultMessage: "\u0936\u094B"
                })
              })
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: "",
            passHref: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
                children: language === "hi" ? "शिकायत" : "Complaints"
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "complaints-paragraph",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          children: "\u0936\u093F\u0915\u093E\u092F\u0924"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
          children: ["\u0905\u0917\u0930 \u0906\u092A \u0939\u092E\u093E\u0930\u0940 \u092A\u095C\u0924\u093E\u0932 \u0915\u0947 \u0924\u0930\u0940\u0915\u0947 \u092F\u093E \u0928\u0924\u0940\u091C\u0947 \u0938\u0947 \u0905\u0938\u0939\u092E\u0924 \u0939\u0948\u0902 \u0924\u094B \u0906\u092A \u0939\u092E\u0947\u0902", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
            href: "mailto:padtaal@lallantop.com",
            children: "padtaal@lallantop.com"
          }), " \u092A\u0930 \u0908\u092E\u0947\u0932 \u092D\u0947\u091C\u0915\u0930 \u0905\u092A\u0928\u0940 \u0938\u0939\u092E\u0924\u093F \u092F\u093E \u0936\u093F\u0915\u093E\u092F\u0924 \u0926\u0930\u094D\u091C \u0915\u0930\u093E \u0938\u0915\u0924\u0947 \u0939\u0948\u0902."]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
          children: ["\u0939\u092E \u0906\u092A\u0915\u0940 \u0905\u0938\u0939\u092E\u0924\u093F \u0915\u093E \u0938\u0902\u091C\u094D\u091E\u093E\u0928 \u095B\u0930\u0942\u0930 \u0932\u0947\u0902\u0917\u0947. \u0905\u0917\u0930 \u0906\u092A\u0915\u094B \u0932\u0917\u0924\u093E \u0939\u0948 \u0915\u093F \u0939\u092E \u0905\u092A\u0928\u0940 \u092A\u095C\u0924\u093E\u0932 \u092E\u0947\u0902 \u0906\u0908\u090F\u092B\u0938\u0940\u090F\u0928 (IFCN) \u0915\u0947 \u0928\u093F\u0930\u094D\u0926\u0947\u0936\u094B\u0902 \u0915\u093E \u092A\u093E\u0932\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902 \u0924\u094B \u0906\u092A", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("a", {
            href: "https://www.ifcncodeofprinciples.poynter.org/complaints-policy",
            target: "_blank",
            rel: "noreferrer",
            children: ["\u0907\u0938 \u0932\u093F\u0902\u0915 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915", " "]
          }), " ", "\u0915\u0930\u0915\u0947 \u0938\u0940\u0927\u0947 \u0906\u0908\u090F\u092B\u0938\u0940\u090F\u0928 \u0915\u094B \u092D\u0940 \u0936\u093F\u0915\u093E\u092F\u0924 \u092D\u0947\u091C \u0938\u0915\u0924\u0947 \u0939\u0948\u0902."]
        })]
      })]
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Complaints);

/***/ }),

/***/ 7423:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/factcheck/complaints",
      function () {
        return __webpack_require__(24792);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [532,2888,179], function() { return __webpack_exec__(7423); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);